import React from 'react';
import { LightbulbIcon } from 'lucide-react';
interface SectionIntroProps {
  title: string;
  description: string;
  whyItMatters: string;
}
export const SectionIntro: React.FC<SectionIntroProps> = ({
  title,
  description,
  whyItMatters
}) => {
  return <div className="mb-6 space-y-3" data-id="element-200">
      <div className="bg-blue-500 bg-opacity-10 border border-blue-500 border-opacity-30 rounded-lg p-4" data-id="element-201">
        <div className="text-sm text-gray-300 leading-relaxed" data-id="element-202">
          {description}
        </div>
      </div>
      <div className="bg-yellow-500 bg-opacity-10 border border-yellow-500 border-opacity-30 rounded-lg p-4" data-id="element-203">
        <div className="flex items-start" data-id="element-204">
          <LightbulbIcon className="w-5 h-5 text-yellow-400 mr-2 flex-shrink-0 mt-0.5" data-id="element-205" />
          <div data-id="element-206">
            <div className="text-sm font-semibold text-yellow-400 mb-1" data-id="element-207">
              Why This Matters
            </div>
            <div className="text-xs text-gray-300 leading-relaxed" data-id="element-208">
              {whyItMatters}
            </div>
          </div>
        </div>
      </div>
    </div>;
};